// frontend/src/main.jsx

import React from "react";
import { createRoot } from "react-dom/client";
import { ApolloProvider } from "@apollo/client";
// import client from "./graphql/client";
import { GoogleOAuthProvider } from "@react-oauth/google";
import App from "./App.jsx";
import ErrorBoundary from "./components/ErrorBoundary.jsx";

// --- Import global CSS ---
import "./styles/main.css";
import { setOracleToken } from "./services/apiV2";

// ✅ Hotfix: Force Token Injection at Runtime
// ⚠️ PORTE 3a — INJECTION RETIREE. `import.meta.env.VITE_*` est INLINEE PAR
//    VITE DANS LE BUNDLE : le jeton partage etait donc lisible par tout
//    visiteur qui ouvrait les sources. Ne jamais y remettre de secret, et en
//    particulier pas une cle API.

// --- Global safety nets ---
window.addEventListener("error", (e) => {
  console.error("[GlobalError]", e.message || e);
});

window.addEventListener("unhandledrejection", (e) => {
  console.error("[UnhandledRejection]", e.reason || e);
});

// --- Build Info (via Vite env) ---
const BUILD_INFO = {
  env: import.meta.env.MODE ?? "development",
  version: import.meta.env.VITE_APP_VERSION ?? "0.0.0",
  commit: import.meta.env.VITE_GIT_SHA ?? "",
};

if (BUILD_INFO.env !== "production") {
  console.log("[Oracle-Entropie] Build info:", BUILD_INFO);
}

// --- Mount React App with Apollo ---
const container = document.getElementById("app");
if (!container) {
  throw new Error("Missing <div id='app'> in index.html");
}

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || "YOUR_CLIENT_ID_PLACEHOLDER";

createRoot(container).render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      {/* <ApolloProvider client={client}> */}
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
      {/* </ApolloProvider> */}
    </GoogleOAuthProvider>
  </React.StrictMode>
);
